import AlibabaSlice from './alibaba.slice';

export const { actions: alibaba_actions } = AlibabaSlice;

export default AlibabaSlice.reducer;
